module.exports = __webpack_public_path__ + "static/media/tuanzhang.e6583fd3.png";